export default function GuaranteeSection() {
  return (
    <section id="guarantee" className="bg-[#060e1a] py-20 md:py-24 relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#f5a623]/20 to-transparent" />

      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <div className="bg-gradient-to-b from-[#f5a623]/10 to-transparent border border-[#f5a623]/25 rounded-3xl p-8 md:p-14 text-center relative overflow-hidden">
          {/* Background ring decoration */}
          <div className="absolute -bottom-16 -right-16 w-80 h-80 rounded-full border border-[#f5a623]/5 pointer-events-none" />
          <div className="absolute -bottom-8 -right-8 w-52 h-52 rounded-full border border-[#f5a623]/10 pointer-events-none" />

          {/* Shield icon */}
          <div className="relative inline-flex items-center justify-center mb-8">
            <div className="w-20 h-20 flex items-center justify-center bg-[#f5a623]/15 rounded-full border-2 border-[#f5a623]/40">
              <i className="ri-shield-check-fill text-[#f5a623] text-4xl" />
            </div>
            <div className="absolute -top-1 -right-1 w-7 h-7 flex items-center justify-center bg-[#f5a623] rounded-full">
              <i className="ri-check-line text-[#0a1628] text-sm font-bold" />
            </div>
          </div>

          {/* Headline */}
          <div className="inline-flex items-center gap-2 bg-[#f5a623]/10 border border-[#f5a623]/30 rounded-full px-4 py-2 mb-5">
            <span className="text-[#f5a623] font-body text-xs font-semibold uppercase tracking-widest">Zero Risk</span>
          </div>

          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-white uppercase leading-tight mb-6">
            30-Day Money Back
            <span className="block text-[#f5a623]">Guarantee.</span>
          </h2>

          <p className="font-body text-base md:text-lg text-white/65 max-w-2xl mx-auto leading-relaxed mb-8">
            We believe in this playbook completely. If you go through the full guide and don't feel it's worth every penny,{' '}
            <strong className="text-white">just email us within 30 days</strong> and we'll refund you immediately — no questions, no hassle, no hard feelings.
          </p>

          {/* Three pillars */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-8">
            {[
              { icon: 'ri-time-fill', title: '30 Days', desc: 'Full refund window' },
              { icon: 'ri-question-answer-fill', title: 'No Questions', desc: 'Zero hassle policy' },
              { icon: 'ri-mail-send-fill', title: 'One Email', desc: "That's all it takes" },
            ].map((item) => (
              <div key={item.title} className="bg-[#0a1628]/60 border border-white/10 rounded-xl p-5 flex flex-col items-center gap-2">
                <div className="w-10 h-10 flex items-center justify-center">
                  <i className={`${item.icon} text-[#f5a623] text-2xl`} />
                </div>
                <p className="font-display text-lg font-bold text-white uppercase">{item.title}</p>
                <p className="font-body text-xs text-white/50">{item.desc}</p>
              </div>
            ))}
          </div>

          <p className="font-body text-sm text-white/35 mt-8">
            Your athlete's success matters to us. We stand behind every word in this playbook.
          </p>
        </div>
      </div>
    </section>
  );
}
